//These styles correspond to protocol breakpoints
// https://protocol.mozilla.org/docs/fundamentals/design-tokens.html
export enum Spacing {
  xSmall = 4,
  Small = 8,
  Default = 12,
  Medium = 16,
  Large = 24,
  xLarge = 32,
  xxLarge = 48,
  layoutLarge = 64,
  layoutXLarge = 96,
}
